import "./Home.module.css";
import DropshippingHero from "@/reusable_sections/Header";
import HeroShowcase from "./sections/HeroShowcase";
import DecorativeDivider from "./sections/DecorativeDivider";
import TheBornBeautifulExperience from "./sections/TheBornBeautifulExperience";
import TheBigDayCountdown from "./sections/TheBigDayCountdown";
import MasonryGallery from "./sections/MasonryGallery";
import WhereWhen from "./sections/WhereWhen";
import JoinOurCelebration from "./sections/JoinOurCelebration";
import BrandFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <DropshippingHero />
      <HeroShowcase />
      <DecorativeDivider />
      <TheBornBeautifulExperience />
      <TheBigDayCountdown />
      <MasonryGallery />
      <WhereWhen />
      <JoinOurCelebration />
      <BrandFooter />
    </div>;
}